// @ts-nocheck
import CommingSoonCountDown from "components/commingsoon-count-down";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState, useContext } from "react";

import { LINK_VIDEO } from "constants/common";
import TheBanner from "layout/TheBanner/TheBanner";
import $ from "jquery";
import Select from "react-select";
import { urlAssetsCustom } from "utils/common";
// import { Html5Qrcode } from "html5-qrcode";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TheFooter from "layout/TheFooter";
import { ReactUtils } from "utils";
import TheFooterInner from "layout/TheFooterInner/TheFooterInner";
import Slider from "react-slick";
import { AudioContext } from "components/AudioProvider/AudioContext";
// import * as styles from "./styles.module.scss";
// import {bgs, than,btn1, btn2, btn3 } from "assets/img"
const HomePageView = (props) => {
  const { 
    isErrorCode,
     provinces,
  provinceSelected,
  remaining,
  handleScroolToElementAction,
  setProvinceSelected, } = props;
  const navigate = useNavigate();
  const phonenumberRef = useRef();
  const fullnameRef = useRef();
  const commingSoon = JSON.parse(localStorage.getItem("commingSoon"));
  const campainEnd = JSON.parse(localStorage.getItem("campainEnd"));
 const listVideo = {
  videos: [
    
    { id: 1, url: "https://www.youtube.com/embed/YejyOmzbFkM" },
    { id: 2, url: "https://www.youtube.com/embed/DmT273MMebY" },
    { id: 3, url: "https://www.youtube.com/embed/oRfohEH5Mq0" },
    { id: 4, url: "https://www.youtube.com/embed/8rNlJdMBmJU" },
    { id: 5, url: "https://www.youtube.com/embed/pQw59Jdfj3w" },
    { id: 6, url: "https://www.youtube.com/embed/dC4BSFOTtXk" },
    { id: 7, url: "https://www.youtube.com/embed/xVK3GMlSISA" },
    { id: 8, url: "https://www.youtube.com/embed/RQv6uZmeMsM" },
    { id: 9, url: "https://www.youtube.com/embed/R71TBoQlEfU" },
    { id: 10, url: "https://www.youtube.com/embed/GPEc3eD_ym0" },
  ],
};

  const sliderRef = useRef(null);
  const videoRefs = useRef([]);

  const settings = {
  dots: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,

  swipe: true,
  swipeToSlide: true,
  touchMove: true,
  draggable: true,

  beforeChange: (current, next) => {
    // Pause video slide cũ
    const oldIframe = videoRefs.current[current];
    if (oldIframe) {
      oldIframe.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "pauseVideo" }),
        "*"
      );
    }
  },

  // afterChange: (current) => {
  //   // Auto play video slide mới
  //   const newIframe = videoRefs.current[current];
  //   if (newIframe) {
  //     newIframe.contentWindow.postMessage(
  //       JSON.stringify({ event: "command", func: "playVideo" }),
  //       "*"
  //     );
  //   }
  // },
};
  return (
    <section className="home-inner">
      <div className="top-home">
        <div className="container">
          <div className="single-button">
                <button onClick={() => handleScroolToElementAction("form_join")}
                    type="button"
                    className="btn btn-primary btn-block btn-border"
                  >
                    <a>Nhận Ngay Voucher bTaskee</a>
                  </button>
               </div>
        </div>
         <img
              className="banner-home"
              src={urlAssetsCustom("assets/img/banner.png")}
              alt="line-bt"
            />
            <div className="box-control container">
              
              <img onClick={() => handleScroolToElementAction("box-1")}
                className="img-control bo2"
                src={urlAssetsCustom("assets/img/bo2.png")}
                alt="line-bt"
              />
              <img onClick={() => handleScroolToElementAction("box-2")}
                className="img-control bo3"
                src={urlAssetsCustom("assets/img/bo3.png")}
                alt="line-bt"
              /> 
              <img onClick={() => handleScroolToElementAction("box-3")}
                className="img-control bo4"
                src={urlAssetsCustom("assets/img/bo4.png")}
                alt="line-bt"
              /> 
            </div>
      </div>
      <div className="container" id="box-1">
        <div className="map-box">
          <div className="map-inner">
            <img
            className="map-img"
            src={urlAssetsCustom("assets/img/title-dt.png")} /> 
            <div className="padd-map">
             
              <div className="map-action">
                <div className="count-warpper" >
                   {remaining?.map((item) => (
                  <div className="count-inner" key={item.id}><span>{item}</span></div>))}
                </div>
                
              <div className="map-text">
              </div>
              </div>
               <img onClick={() => handleScroolToElementAction("form_join")}
                className="btn-map"
                src={urlAssetsCustom("assets/img/Sun-Button-1.png")}
                alt="line-bt"
              />
              <img
              className="map-img"
              src={urlAssetsCustom("assets/img/bg-map.png")}/> 

            </div>
            <p className="text-map">2000 mã khuyến mãi mỗi ngày với 3 bước đơn giản</p>
            <div className="step step1">
              <h3>Bước 1:</h3>
              <p>Khách hàng đọc & chấp nhận <br/>
                <a onClick={() => navigate("/rule")}
                  
                >
                  Thể lệ tham dự chương trình
                </a>
              </p>
            </div>
            <div className="step step2">
                 <img
            className="sticker1"
            src={urlAssetsCustom("assets/img/mai.png")} /> 
            <img
            className="sticker3"
            src={urlAssetsCustom("assets/img/sticker1.png")} /> 
              <h3>Bước 2:</h3>
              <p>Khách hàng điền thông tin tên,<br/> số điện thoại & địa chỉ</p>
            </div>
            <div className="step step3">
              <h3>Bước 3:</h3>
              <p>Voucher bTaskee 30k sẽ được gửi về số điện thoại đã đăng kí. Khách hàng lưu lại số này để sử dụng khi thanh toán trên ứng dụng bTaskee</p>
             <img
            className="sticker2"
            src={urlAssetsCustom("assets/img/sticker2.png")} />
            </div>
         
            
          </div>
            
        </div>
         <div className="single-button btnVoucher">
                <button onClick={() => handleScroolToElementAction("form_join")}
                    type="button"
                    className="btn btn-primary btn-block btn-border"
                  >
                    <a>Nhận Ngay Voucher bTaskee</a>
                  </button>
               </div>
      </div>
      <div className="container"  id="form_join">
        <section className="register-warp">
          <div className="register-inner">
            <h2>
              <img
                className="img-control"
                src={urlAssetsCustom("assets/img/title-form.png")}
                alt="line-bt"
                /> 
            </h2>

        <div className="imai"></div>
            <div className="container"  >
              <div className="register">
                <form className="register-form" onSubmit={props.handleSubmit} >
                  <div className="form-group">
                      <label className="title-form" htmlFor="usr">
                        Họ và tên <span>*</span>
                      </label>
                      <div className="form-field">
                        <input
                          type="text"
                          className="form-control"
                        
                            {...props.register("fullName", {
                          onChange: (elm) => {
                            props.setValue(
                              "fullName",
                              elm.target.value
                            );
                          },
                        })}
                          id="fullName"
                          name="fullName"
                          placeholder="Nhập họ và tên..."
                          maxLength={50}
                          min="0"
                          max="50"
                        />
                      </div>
                    </div>
                      <div className="form-group">
                    <label className="title-form" htmlFor="phone">
                      Số điện thoại <span>*</span>
                    </label>

                    <div className="form-field">
                      {/* <img
                        src={urlAssetsCustom("assets/img/icon/close-input.png")}
                        alt="text-info "
                        className="clear-icon"
                        onClick={() => props?.clearFieldFormData("phone")}
                      /> */}
                      <input
                        type="tel"
                        // disabled={commingSoon || campainEnd}
                        className={`form-control ${
                          props?.isErrorPhoneNumber && "errors"
                        }`}
                        ref={phonenumberRef}
                        id="phone"
                        maxLength={10}
                        name="phone"
                        {...props.register("phone", {
                          onChange: (elm) => {
                            props.setValue(
                              "phone",
                              elm.target.value.replace(/[^\d]/gi, "")
                            );
                          },
                        })}
                        placeholder="Nhập số điện thoại..."
                        min="0"
                        max="10"
                        inputMode="numeric"
                      />
                    </div>
                    {props?.isErrorPhoneNumber && (
                      <small className="errors">Số điện thoại không hợp lệ</small>
                    )}
                  </div>
                    <div className="form-group">
                      <label className="title-form" htmlFor="usr">
                        Tỉnh/Thành phố <span>*</span>
                      </label>

                      <Select
                        className={`form-control `}
                        placeholder="Chọn"
                        options={provinces}
                        value={provinces.filter(
                          ({ value }) => value === provinceSelected?.value
                        )}
                        onChange={(e) => {
                          setProvinceSelected(e); 
                          props.setValue(
                          "provinces",e)
                        }}
                      />
                    </div>
                  <div className={`group-checkbox`}>
                    <div className="checkbox-item">
                      <label htmlFor="isAgree">
                        <input
                          type="checkbox"
                          value="isAgree"
                          name="isAgree"
                          id="isAgree"
                          {...props.register("isAgree")}
                        />
                        <span className="checkmark"></span>
                        <p>
                          Tôi xác nhận trên 16 tuổi, đã đọc và đồng ý với các {" "} 
                          <a
                        className="policy"
                        target="_blank"
                        href="https://www.unilevernotices.com/vietnam/vietnamese/privacy-notice/notice.html"
                        rel="noreferrer"
                      >
                        Điều khoản sử dụng
                      </a>{" "}
                          và <a
                        className="policy"
                        target="_blank"
                        href="https://www.unilevernotices.com/vietnam/vietnamese/cookie-notice/notice.html"
                        rel="noreferrer"
                      >
                        Chính sách bảo mật
                      </a> của Sunlight
                        </p>
                      </label>
                    </div>
                    <br />
                    {/* <p>
                      Bằng việc đăng ký, tôi xác nhận trên 16 tuổi và đã đọc thông
                      báo về{" "}
                      <a
                        className="policy"
                        target="_blank"
                        href="https://www.unilevernotices.com/vietnam/vietnamese/privacy-notice/notice.html"
                        rel="noreferrer"
                      >
                        Quyền riêng tư
                      </a>{" "}
                      và{" "}
                      <a
                        className="policy"
                        target="_blank"
                        href="https://www.unilevernotices.com/vietnam/vietnamese/cookie-notice/notice.html"
                        rel="noreferrer"
                      >
                        thông báo cookies
                      </a>{" "}
                      của Unilever để hiểu cách Unilever sử dụng thông tin của
                      tôi.
                    </p> */}
                    {/* <div className="checkbox-item">
                      <label htmlFor="isAgree1">
                        <input
                          type="checkbox"
                          value="isAgree1"
                          name="isAgree1"
                          id="isAgree1"
                          {...props.register("isAgree1")}
                        />
                        <span className="checkmark"></span>
                        <p>
                          Tôi đồng ý với điều khoản sử dụng của ACECOOK và đã được
                          thông báo về{" "}
                          <a
                            className="policy"
                            target="_blank"
                            href="https://www.unilevernotices.com/vietnam/vietnamese/privacy-notice/notice.html"
                            rel="noreferrer"
                          >
                            Quyền riêng tư
                          </a>
                          ,{" "}
                          <a
                            className="policy"
                            target="_blank"
                            href="https://www.unilevernotices.com/vietnam/vietnamese/cookie-notice/notice.html"
                            rel="noreferrer"
                          >
                            thông báo cookies
                          </a>{" "}
                          và{" "}
                          <a
                            className="policy"
                            target="_blank"
                            href="https://www.unilever.com.vn/legal.html"
                            rel="noreferrer"
                          >
                            Thông tin pháp lý.
                          </a>
                        </p>
                      </label>
                    </div>
                    <div className="checkbox-item">
                      <label htmlFor="isAgree2">
                        <input
                          type="checkbox"
                          value="isAgree2"
                          name="isAgree2"
                          id="isAgree2"
                          {...props.register("isAgree2")}
                        />
                        <span className="checkmark"></span>
                        <p>
                          Tôi xác nhận những thông tin đăng ký ở trên là chính xác
                          và chịu trách nhiệm trước Pháp luật về tính chính xác
                          của các thông tin trên
                        </p>
                      </label>
                    </div> */}
                  </div>
                  <div className="btn-wrapper">
                  <button
                      type="submit"
                      className="btn btn-primary btn-block btn-border"
                      id="btn-register"
                    >
                      <a>XÁC NHẬN</a>
                    </button>
                </div>
                </form>
                
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="container box-2" id="box-2">
        <div className="imai"></div>
        <div className="map-box">
          <div className="map-inner">
            <img
            className="map-img"
            src={urlAssetsCustom("assets/img/title-3.png")} /> 
            
            <img
            className="sticker3"
            src={urlAssetsCustom("assets/img/sticker1.png")} /> 
             <img
            className="sticker2"
            src={urlAssetsCustom("assets/img/sticker2.png")} />
            <Slider ref={sliderRef} {...settings}>
      {listVideo.videos.map((item, index) => (
        <div key={item.id} className="slider-warp">
          <div className="videoWrapper">
            <iframe
              ref={(el) => (videoRefs.current[index] = el)}
              width="100%"
              height="100%"
              src={item.url.includes("?") ? item.url + "&enablejsapi=1" : item.url + "?enablejsapi=1"}
              title={"Video " + item.id}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      ))}
    </Slider>
             <div className="single-button">
                <button  onClick={() => window.open("https://www.tiktok.com/@sunlight.vietnam", "_blank")}

                    type="button"
                    className="btn btn-primary btn-block btn-border"
                  >
                    <a>XEM THÊM TRÊN TIKTOK</a>
                  </button></div>
          </div>
        </div>
         
      </div>
      <div className="container box-3" id="box-3">
        <div className="imai"></div>
        <div className="map-box">
          <div className="map-inner">
            <img
            className="map-img"
            src={urlAssetsCustom("assets/img/title-4.png")} /> 
            
           
            <div className="container">
              <div className="videoWrapper">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Z9sHsU5AlwI?si=o6nL1NwAkJt9w2KA&enablejsapi=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>
           
             <div className="single-button">
                <button  onClick={() => window.open("https://www.tiktok.com/@sunlight.vietnam", "_blank")}

                    type="button"
                    className="btn btn-primary btn-block btn-border"
                  >
                    <a>XEM THÊM TRÊN TIKTOK</a>
                  </button>
            </div>
          </div>
        </div>
         
      </div>
    
      {/* <div className="line"></div> */}
      
      {/* <img
        id="guide_join"
        className="img-full"
        src={urlAssetsCustom("assets/img/guide-img.png")}
        alt=""
      />
      <img
        className="img-full"
        src={urlAssetsCustom("assets/img/pro-img.png")}
        alt=""
      />
      <TheFooterInner /> */}
    </section>
  );
};
export default HomePageView;
